<template lang="pug">
  .wrap

    template(v-if='!showPlaceholder')
      page-title Your Courses
        fa-icon.tooltip-icon-p(icon="info-circle" size="xs" :style="{position: 'relative', margin:'0 3px', fontSize:'0.75rem'}" v-tooltip.top="{ content:'To report on a single course or to compare more than one course, search to add courses below.', classes:'ethos-tooltip'}")

      list-header(:on-search='search')
        template(slot='action')
          el-button(@click='onReload')
            icon(name='redo')
          router-link(:to="{ name: 'itrain:courseCreate' }")
            el-button(type="primary") Add New Course

      el-table(:data="list.results" empty-text="No entries" v-loading='loading' @sort-change='changeSort')
        el-table-column(width="80" align='center' label='Published' class-name='status-cell')
          template(slot-scope="scope")
            icon.status-icon(v-if='scope.row.status === "published"' name='check-circle' color='#7fc4be')
            icon.status-icon(v-if='scope.row.status === "draft"' name='times-circle' color='#dd6e69')


        el-table-column(width="80" align='center' label='SCORM Status' class-name='status-cell')
          template(slot-scope="scope")
            template(v-if='scope.row.hasScormArchiveFile')
              icon.status-icon(v-if='scope.row.scormProcessingStatus === "in_progress"' name='sync' spin color='#F7BA2A')
              icon.status-icon(v-if='scope.row.scormProcessingStatus === "success"' name='check-circle' color='#7fc4be')
              icon.status-icon(v-if='scope.row.scormProcessingStatus === "fail"' name='times-circle' color='#dd6e69')

            icon.status-icon(v-else name='minus' color='#ddd')


        el-table-column(label="Course" prop='name' class-name='title-cell' min-width="220")
          template(slot-scope="scope")
            router-link(:to="{ name: 'itrain:courseEdit', params: { courseId: scope.row.id } }")
              | {{ scope.row.title }}

        el-table-column(label="Users assigned" prop='type' width="140" align="center")
          template(slot-scope="scope")
            | {{ scope.row.assignedUsersCount }}

        el-table-column(label="Users completed" prop='type' width="100" align="center")
          template(slot-scope="scope")
            | {{ scope.row.totalCompletedCount }}

        el-table-column(label="Pass rate" prop='type' width="140" align="center")
          template(slot-scope="scope")
            | {{ scope.row.averagePassRate ? `${scope.row.averagePassRate}%` : '-' }}

        el-table-column(label="Type" prop='type' width="100")
          template(slot-scope="scope")
            el-tag {{ formatType(scope.row.type) }}

        el-table-column(width='350' align='right')
          template(slot-scope="scope")
            el-button-group
              router-link(:to="{ name: 'itrain:courseReport', params: { courseId: scope.row.id } }")
                el-button(size='small')
                  icon.report-icon(name='chart-bar' color='#999')
                  | Report
              router-link(:to="{ name: 'itrain:courseEdit', params: { courseId: scope.row.id } }")
                el-button(size='small')
                  icon.report-icon(name='edit' color='#999')
                  | Edit
              a(v-if='authedScormEntrypointUrl(scope.row)' :href="authedScormEntrypointUrl(scope.row)" target="_blank")
                el-button(size='small')
                  icon.report-icon(name='edit' color='#999')
                  | Preview

      .pages
        el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')

    .empty(v-else)
      empty-list

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import qs from "query-string";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";
import isPast from "date-fns/is_past";

import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";
import EmptyList from "../EmptyList";

const COURSE_TYPE_NAMES = {
  scorm: "SCORM",
  custom: "Custom"
};

export default {
  components: { PageTitle, ListHeader, EmptyList },
  data() {
    return {
      loading: true,
      pageSize: 20,
      searchParams: null,
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      authToken: "auth/token"
    }),
    showPlaceholder() {
      return !this.loading && !this.searchParams && !this.list.count;
    }
  },
  methods: {
    ...mapActions({
      fetchCourses: "courses/fetchCourses"
    }),
    onReload() {
      this.loadList();
    },
    loadList({ params, showLoader = true } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        ...params
      };
      if (showLoader) {
        this.loading = true;
      }
      this.fetchCourses({ params: mergedParams }).then(data => {
        this.loading = false;
        this.list = data;
      });
    },
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: { q } });
    },
    changeSort({ prop, order }) {
      if (!order) {
        this.loadList();
        return;
      }
      const sortVal = (order === "ascending" ? "" : "-") + prop;
      this.loading = true;
      this.loadList({ params: { sort: sortVal } });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    },
    formatTimeRemaining(module) {
      return isPast(module.endDatetime)
        ? "-"
        : distanceInWordsStrict(new Date(), module.endDatetime);
    },
    formatType(type) {
      return COURSE_TYPE_NAMES[type];
    },
    authedScormEntrypointUrl(course) {
      if (!course.scormEntrypoint) {
        return;
      }
      return (
        course.scormEntrypointUrl +
        "?" +
        qs.stringify({ token: this.authToken, mode: "preview" })
      );
    }
  },
  created() {
    this.loadList();
    // Disabling auto-refresh as this causes a race condition with the call to change page,
    // which causes the paged results to be overwritten from the other API call results.

    // this.refreshIntervalId = setInterval(() => {
    //   this.loadList({ showLoader: false });
    // }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.refreshIntervalId);
  }
};
</script>

<style scoped lang="scss">
.emptystate {
  width: 100%;
}

.message {
  font-size: 13px;
  color: #666;
  line-height: 20px;
}

.wrap {
  :global(td.stat-cell .cell) {
    font-size: 16px;
    line-height: 20px;
    padding: 20px 0;
  }

  :global(.el-table td) {
    height: 60px;
  }

  :global(.el-table th .cell) {
    font-size: 11px;
    line-height: 15px;
    word-break: normal;
  }

  :global(td .cell) {
    line-height: 24px;
  }

  :global(.status-cell .cell) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :global(td.title-cell) {
    font-size: 16px;
    cursor: pointer;
  }
}

.schedule {
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;
}

.schedule-time {
  font-size: 16px;
}

.schedule-day {
  color: #666;
}

.report-icon {
  margin-right: 8px;
}

.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  padding: 80px 0;
  flex-direction: column;
}

.placeholder-actions {
  margin-top: 30px;
}

.emptystate {
  width: 100%;
}

.assigned-group {
  margin-right: 5px;
  margin-bottom: 4px;
  &:last-child {
    margin-right: 0;
  }
}
</style>
